/**
 * Strip an attached .html/.htm file down to readable text so agents analyse the
 * content, not the markup (and we don't burn tokens on tags). Runs client-side via
 * the browser DOMParser; falls back to a regex strip if DOMParser is unavailable.
 */

/** True for a file we should treat as HTML (by extension or reported MIME). */
export function isHtmlFile(name: string, type?: string): boolean {
  return /\.html?$/.test((name || '').toLowerCase()) || (type || '').toLowerCase() === 'text/html';
}

/** Convert an HTML string to readable plain text (drops script/style/noscript). */
export function htmlToText(html: string): string {
  const src = html || '';
  try {
    if (typeof DOMParser !== 'undefined') {
      const doc = new DOMParser().parseFromString(src, 'text/html');
      doc.querySelectorAll('script, style, noscript').forEach((el) => el.remove());
      const text = doc.body?.textContent ?? doc.textContent ?? '';
      return tidy(text);
    }
  } catch { /* fall through to regex strip */ }
  return tidy(src.replace(/<(script|style)[\s\S]*?<\/\1>/gi, ' ').replace(/<[^>]+>/g, ' '));
}

/** Collapse the whitespace an HTML strip leaves behind. */
function tidy(text: string): string {
  return text
    .replace(/[ \t]+/g, ' ')
    .replace(/ *\n */g, '\n')
    .replace(/\n{3,}/g, '\n\n')
    .trim();
}
